import React, { Component } from "react";
import { Link, NavLink } from "react-router-dom";
import {
  Row,
  Col,
  Icon,
  Button,
  Dropdown,
  Menu,
  List,
  Divider,
  Modal,
  message
} from "antd";
import moment from "moment";
import F from "../../Functions";
import axios from "../../api";
import NotesModal from "./parts/notes-modal";
import TransferBFile from "./parts/transfer-bfile-modal";
import ChangeCreatorModal from "./parts/change-creator-modal";
import EditBFileStatusModal from "./parts/edit-bfile-status-modal";
import SetupAppointment from "./parts/setup-appointment-modal";
import SetupAppointmentVon from "./parts/setup-appointment-modal-vo";
import InvitationLinkModal from "./parts/invitation-link-modal";
import ResendMortgageApprovalModal from "./parts/resend-mortgage-approval";
import Print from "./parts/print";
import PrintPdf from "../../components/print-pdf/print-index";
import PrintableContent from "../../components/print-pdf/PrintableContent";
import { HandlePrint } from "../../components/print-pdf/printLogic"
import { Translate } from "react-translated";

import DownArrowIcon from "./images/new/down-arrow.png";
import DeleteModal from "./parts/DeleteModal";
import { AGENCY_MANAGER, EA, VONSCHEDULER } from "../../utils/Constants";
import { useBoundStore } from "../../store/useBoundStore";

const confirm = Modal.confirm;

class ActionMenu extends Component {
  printRef = React.createRef();
  state = {
    visible: false,
    loading: true,
    user: this.props.user,
    setup_appointment_modal: false,
    setup_appointment_modal_von: false,
    edit_bfile_status_modal: false,
    show_notes_modal: false,
    transfer_bfile_modal: false,
    change_creator_modal: false,
    invitation_link_modal: false,
    show_print_modal: false,
    data: {},
    agency_owner_details: {},
    show_delete_modal: false,
  };
  // printRef = React.createRef();
  componentDidMount() {

    // if (this.state.user.user_type === "LSP" || this.state.user.user_type === "EA") {
    //   axios.get("/api/get_agency_owner_details").then(({ data: { error_response, agency_owner_details, success } }) => {
    //     if (success && !error_response) {
    //       this.setState({ agency_owner_details });
    //     } else {
    //       message.error(error_response)
    //     }

    //   })
    // }

    // axios.get("/api/user").then((res) => {
    //   let myData = {};
    //   const user = res.data;

    //   // Set carrier
    //   if (user.carrier) {
    //     myData.carrier = user.carrier;
    //   } else if (user.invited_user && user.invited_user.carrier) {
    //     myData.carrier = user.invited_user.carrier;
    //   }

    //   // Set minimum_liability_limits_ext
    //   if (user.minimum_liability_limits_ext) {
    //     myData.minimum_liability_limits_ext = JSON.parse(user.minimum_liability_limits_ext);
    //   } else if (user.invited_user && user.invited_user.minimum_liability_limits_ext) {
    //     myData.minimum_liability_limits_ext = JSON.parse(user.invited_user.minimum_liability_limits_ext);
    //   }

    //   // Set minimum_liability_limits
    //   if (user.minimum_liability_limits) {
    //     myData.minimum_liability_limits = user.minimum_liability_limits;
    //   } else if (user.invited_user && user.invited_user.minimum_liability_limits) {
    //     myData.minimum_liability_limits = user.invited_user.minimum_liability_limits;
    //   }

    //   this.setState({ data: myData });
    // });
  }

  edit = () => {
    this.props.history.push("/wizard/step/1/" + this.state.bfile.id);
  };
  goTo = (path) => {
    this.props.history.push({
      pathname: path,
      state: { ...this.props.history.location.state }
    });
  };
  print = () => {
    this.setState({
      loading: true
    })
    if (this.state.user.user_type === "LSP" || this.state.user.user_type === "EA") {
      axios.get("/api/get_agency_owner_details").then(({ data: { error_response, agency_owner_details, success } }) => {
        if (success && !error_response) {
          this.setState({ agency_owner_details });
        } else {
          message.error(error_response)
        }

      }).catch((err) => {
        console.log("error", err)
      })
    }

    axios.get("/api/user").then((res) => {
      let myData = {};
      const user = res.data;

      // Set carrier
      if (user.carrier) {
        myData.carrier = user.carrier;
      } else if (user.invited_user && user.invited_user.carrier) {
        myData.carrier = user.invited_user.carrier;
      }

      // Set minimum_liability_limits_ext
      if (user.minimum_liability_limits_ext) {
        myData.minimum_liability_limits_ext = JSON.parse(user.minimum_liability_limits_ext);
      } else if (user.invited_user && user.invited_user.minimum_liability_limits_ext) {
        myData.minimum_liability_limits_ext = JSON.parse(user.invited_user.minimum_liability_limits_ext);
      }

      // Set minimum_liability_limits
      if (user.minimum_liability_limits) {
        myData.minimum_liability_limits = user.minimum_liability_limits;
      } else if (user.invited_user && user.invited_user.minimum_liability_limits) {
        myData.minimum_liability_limits = user.invited_user.minimum_liability_limits;
      }

      this.setState({ data: myData });
    }).then(() => {
      this.setState({ show_print_modal: true }, () => {
        if (typeof this.props.is_callpage !== "undefined") {
          const { bfile } = this.props;
          this.props.history.push("/customer/" + bfile.id);
        }
      })
    }).catch((err) => {
      console.log("err", err)
    })
    this.setState({ loading: false })

  };
  archive = () => {
    const { bfile, user } = this.props;
    this.setState({ loading: true });

    axios.put("/api/b_file/" + bfile.id, { archive: 1 }).then((res) => {
      axios.post("/api/bfile_notes", {
        bfile_id: bfile.id,
        note: "B File archived - " + moment().format("MM/DD/YYYY hh:mmA"),
        user_id: user.id,
        action: "Archive"
      });

      this.setState({ loading: false }, () => {
        if (typeof this.props.refresh !== "undefined") {
          this.props.refresh();
        } else {
          this.props.history.push("/dashboard");
        }
      });
    });
  };
  sendNotification = (bfile) => {
    // let { email, agency: { primary_ea_id } } = bfile

    // let data = {
    //     notification_message: `The phone number of the customer (${email}) is not valid, Kindly change it`,
    //     user_ids: [primary_ea_id],
    //     severity: "low",
    //     dispatch_time: Math.floor(Date.now() / 1000)
    // }

    axios
      .post("/api/get_all_user_for_bad_phone_number_notification", {
        agency_id: bfile.agency_id
      })
      .then((res) => {
        if (res.data.data.length) {
          let data = {
            notification_message: `The phone number for ${bfile.first_name}, ${bfile.last_name} is not valid. Please update it.`,
            user_ids: res.data.data,
            severity: "low",
            dispatch_time: Math.floor(Date.now() / 1000),
            bfile_id: bfile.id
          };
          axios.post("/api/create_notification", data).then((res) => {
            message.success(F.translate(`Notification Sent Successfully`));
          });
        } else {
          message.info(F.translate(`No Users to Notify`));
        }

        // this.setState({
        //     bad_phone : res.data.data
        // })
      })
      .catch((error) => {
        F.showAndHandleServerError(error);
      });
  };
  complete = (bfile_id) => {
    this.setState({ loading: true });

    axios
      .put("/api/b_file/" + bfile_id, {
        // rs_archived: 1,
        // vob_archived: 1,
        bfile_folow_up_completed: 1
      })
      .then(() => {


        axios.post("/api/bfile_notes", {
          bfile_id: bfile_id,
          note: "B File Marked as Complete - " + moment().format("MM/DD/YYYY hh:mmA"),
          user_id: this.state.user.id,
          action: "Mark as Complete"
        }).finally(() => {

          this.setState({ loading: false }, () => {
            if (typeof this.props.refresh !== "undefined") {
              this.props.refresh();
            } else {
              this.props.history.push("/dashboard");
            }
          });


        })
      });
  };
  vobComplete = (bfile_id) => {
    const { user } = this.props;
    this.setState({ loading: true });

    axios.post("/api/bfile_notes", {
      bfile_id: bfile_id,
      note: "Not interested.",
      user_id: user.id,
      action: "Complete"
    });

    axios
      .put("/api/b_file/" + bfile_id, {
        vob_archived: 1
      })
      .then(() => {

        axios.post("/api/bfile_notes", {
          bfile_id: bfile_id,
          note: "B File Marked as Complete - " + moment().format("MM/DD/YYYY hh:mmA"),
          user_id: this.state.user.id,
          action: "Mark as Complete"
        }).finally(() => {

          this.setState({ loading: false }, () => {
            if (typeof this.props.refresh !== "undefined") {
              this.props.refresh();
            } else {
              this.props.history.push("/dashboard");
            }
          });

        })
      });
  };

  onDeleteOk = () => {
    this.setState({ isDeleting: true });
    const that = this;
    const { bfile, user } = this.props;

    that.setState({ loading: true });
    if (user.user_type !== "EFS") {
      axios.put("/api/b_file/" + bfile.id, { deleted: 1 }).then((res) => {
        useBoundStore.getState().setFsFilters({
          page: 1
        })
        axios.post("/api/bfile_notes", {
          bfile_id: bfile.id,
          note: "B File deleted - " + moment().format("MM/DD/YYYY hh:mmA"),
          user_id: user.id,
          action: " Delete B File "
        });
        that.setState({ loading: false }, () => {
          if (typeof that.props.refresh !== "undefined") {
            that.props.refresh();
            window.location.reload();
          } else {
            that.props.history.push("/dashboard");
          }
        });
      });
    } else {
      axios.get("/api/user_need_attention").then(function (res) {
        const data = res.data;
        for (var i = 0; i < data.length; i++) {
          if (data[i].bfile_id == bfile.id) {
            axios.delete("/api/need_attention/" + data[i].id);
          }
        }
        axios
          .get(
            '/api/calendar_invite?q={"filters":[{"name":"bfile_id","op":"==","val":' +
            bfile.id +
            "}]}"
          )
          .then(function (res) {
            const data = res.data;
            for (var i = 0; i < data.length; i++) {
              if (data[i].bfile_id == bfile.id) {
                axios.delete("/api/need_attention/" + data[i].id);
              }
            }
            that.setState({ loading: false }, () => {
              if (typeof that.props.refresh !== "undefined") {
                that.props.refresh();
              } else {
                that.props.history.push("/dashboard");
              }
            });
          });
      });
    }
  }
  hideModal = () => {
    this.setState({
      show_delete_modal: false
    });
  }
  // delete = () => {
  //   const that = this;
  //   const { bfile, user } = this.props;
  //   const parentInstance = this;

  //   return (
  //     <DeleteModal parentInstance={parentInstance} onDeleteOk={this.onDeleteOk} />
  //   )

  // };
  toggleVIP = () => {
    const { bfile } = this.props;

    if (bfile.vip === 0) bfile.vip = 1;
    else bfile.vip = 0;

    this.setState({ loading: true });
    axios.put("/api/b_file/" + bfile.id, { vip: bfile.vip }).then((res) => {
      this.setState({ loading: false });
      this.props.update(bfile);
    });
  };
  toggleSP500 = () => {
    const { bfile } = this.props;

    if (bfile.sp_500 === 0) bfile.sp_500 = 1;
    else bfile.sp_500 = 0;

    this.setState({ loading: true });
    axios
      .put("/api/b_file/" + bfile.id, { sp_500: bfile.sp_500 })
      .then((res) => {
        this.setState({ loading: false });
        this.props.update(bfile);
      });
  };
  removeFinancialSpecialist = () => {
    const { bfile } = this.props;

    this.setState({ loading: true });
    axios.put("/api/b_file/" + bfile.id, { financial_id: null }).then((res) => {
      this.setState({ loading: false });
      this.props.history.push("/dashboard");
    });
  };
  cancelAppointment = (bfile_id) => {
    this.setState({ loading: true });
    axios.put("/api/b_file/" + bfile_id, { rs_action: 0 }).then((res) => {
      this.setState({ loading: false });
      this.props.history.push("/dashboard");
    });
  };
  // createQuickFollowUpCall = () => {
  //   const { bfile } = this.props;

  //   window.localStorage.bfileType = "quick";
  //   window.localStorage.removeItem("wizard");

  //   setTimeout(() => {
  //     this.props.history.push("/wizard/step/13/" + bfile.id, {
  //       quickFollowUp: true,
  //     });
  //   }, 100);
  // };

  showConfirmationModal = () => {
    Modal.confirm({
      title: "Confirmation",
      content: "Call Attempted multiple times, do you still want to continue?",
      onOk: () => {
        setTimeout(
          () => this.setState({ setup_appointment_modal_von: true }),
          200
        );
      },
      // onCancel: () => {
      //   setTimeout(() => this.props.history.replace("/dashboard"), 200);
      // },
      okText: "Yes",
      cancelText: "No",
      okButtonProps: {
        className: 'borderRadius-28 bg-164897'
      },
      cancelButtonProps: {
        className: 'borderRadius-28'
      }
    });
  };

  /**
   * Method will render `Complete` button action and will
   * call only for `Agency Owner` and `Agency Staff`
   * @returns
   */
  renderCompleteButtonForAgencyOwnerAgencyStaff = () => {
    const { bfile } = this.props;

    // const isAppScheduledAndBFileNotComplete = F.isVirtualFollowUpAppointmentScheduledAndBFileNotCompleted(
    //   bfile
    // );

    const isVonBorderBFileCompleted = F.isVonBorderBFileCompleted(bfile);
    const isBFileClaimedAndScheduledFollowUpApp = F.isBFileClaimedAndAppointmentScheduledFromVonBoarder(
      bfile
    );
    return !isVonBorderBFileCompleted &&
      isBFileClaimedAndScheduledFollowUpApp ? (
      <Menu.Item
        key="setup-appointment"
        onClick={() => this.complete(bfile.id)}
      >
        <Icon type="check" style={{ marginRight: 10, color: "#1890ff" }} />
        <Translate text={`Complete`} />
      </Menu.Item>
    ) : null;
  };

  render() {
    const { bfile, loading, user } = this.props;

    let can_onboard = false;
    let can_do_financial = false;
    if (
      user.user_type === "LSP" &&
      typeof user.jobs !== "undefined" &&
      user.jobs !== null &&
      user.jobs !== ""
    ) {
      const jobs = JSON.parse(user.jobs);
      if (jobs.onboarding) {
        can_onboard = true;
      }
      if (jobs.life_licensed) {
        can_do_financial = true;
      }
    }
    if (user.user_type === "EA") {
      can_onboard = true;
      can_do_financial = true;
    }
    if (user.user_type === "EFS") {
      can_do_financial = true;
    }

    let menu = <Menu />;
    if (
      user.id !== 2 &&
      (user.user_type === "EA" ||
        user.user_type === "LSP" ||
        user.user_type === "EFS")
    ) {
      menu = (
        <Menu>
          {typeof this.props.is_callpage !== "undefined" ? (
            <Menu.Item
              key="profile"
              onClick={() => this.goTo("/customer/" + bfile.id)}
            >
              <Icon type="user" style={{ marginRight: 10, color: "#1890ff" }} />
              <Translate text={`View Profile`} />
            </Menu.Item>
          ) : null}
          {typeof this.props.is_callpage !== "undefined" ? (
            <Menu.Divider />
          ) : null}

          {
            this.props && this.props.history &&
            this.props.history.location &&
            this.props.history.location.pathname &&
            this.props.history.location.pathname.includes("/customer") && (
              <Menu.Item key="print" onClick={() => this.print()}>
                <Icon
                  type="printer"
                  style={{ marginRight: 10, color: "#1890ff" }}
                />
                <Translate text={`Print Profile`} />
              </Menu.Item>
            )
          }



          <Menu.Item key="delete" onClick={() => this.setState({ show_delete_modal: true })}>
            <Icon type="delete" style={{ marginRight: 10, color: "#1890ff" }} />
            <Translate text={`Delete B File`} />
          </Menu.Item>
          {user.user_type !== "EFS" ? (
            <Menu.Item
              key="change-creator"
              onClick={() => this.setState({ change_creator_modal: true })}
            >
              <Icon type="user" style={{ marginRight: 10, color: "#1890ff" }} />
              <Translate text={`Change B File Creator`} />
            </Menu.Item>
          ) : null}

          {user.user_type !== "EFS" ? <Menu.Divider /> : null}
          {user.user_type !== "EFS" ? (
            <Menu.Item
              key="invitation-link"
              onClick={() => this.setState({ invitation_link_modal: true })}
            >
              <Icon type="link" style={{ marginRight: 10, color: "#1890ff" }} />
              <Translate text={`Copy Intelligence Link`} />
            </Menu.Item>
          ) : null}
          {user.user_type !== "EFS" && bfile.mortgage_review === 1 ? (
            <Menu.Item
              key="resend-mortgage-approval"
              onClick={() =>
                this.setState({ resend_mortgage_approval_modal: true })
              }
            >
              <Icon type="mail" style={{ marginRight: 10, color: "#1890ff" }} />
              <Translate text={`Resend Mortgage Approval`} />
            </Menu.Item>
          ) : null}
        </Menu>
      );
    }
    if (user.user_type === "MORTGAGE_BROKER") {
      menu = (
        <Menu>
          {typeof this.props.is_callpage !== "undefined" ? (
            <Menu.Item
              key="profile"
              onClick={() => this.goTo("/customer/" + bfile.id)}
            >
              <Icon type="user" style={{ marginRight: 10, color: "#1890ff" }} />
              <Translate text={`View Profile`} />
            </Menu.Item>
          ) : null}

        </Menu>
      );
    }
    if (user.user_type === "VONBOARDER" || user.id === 2 || (
      user.user_type === "SUPER_ADMIN"
      && this.props.history.location.state &&
      this.props.history.location.state.user_type && this.props.history.location.state.user_type === 'BOBADMIN'
    )) {
      menu = (
        <Menu>
          {typeof this.props.is_callpage !== "undefined" ? (
            <Menu.Item
              key="profile"
              onClick={() => this.goTo("/customer/" + bfile.id)}
            >
              <Icon type="user" style={{ marginRight: 10, color: "#1890ff" }} />
              <Translate text={`View Profile`} />
            </Menu.Item>
          ) : null}

        </Menu>
      );

    }

    if (user.user_type === "REVIEWSCHEDULER") {
      menu = (
        <Menu>
          {typeof this.props.is_callpage !== "undefined" ? (
            <Menu.Item
              key="profile"
              onClick={() => this.goTo("/customer/" + bfile.id)}
            >
              <Icon type="user" style={{ marginRight: 10, color: "#1890ff" }} />
              <Translate text={`View Profile`} />
            </Menu.Item>
          ) : null}

        </Menu>
      );
    }





    if (user.user_type === VONSCHEDULER) {
      menu = (
        <Menu>
          <Menu.Item
            key="profile"
            onClick={() => this.goTo("/customer/" + bfile.id)}
          >
            <Icon type="user" style={{ marginRight: 10, color: "#1890ff" }} />
            <Translate text={`View Profile`} />
          </Menu.Item>
        </Menu>
      );
    }



    if (user.user_type === AGENCY_MANAGER) { //need to change to agency manager
      menu = (
        <Menu>
          <Menu.Item
            key="profile"
            onClick={() => this.goTo("/customer/" + bfile.id)}
          >
            <Icon type="user" style={{ marginRight: 10, color: "#1890ff" }} />
            <Translate text={`View Profile`} />
          </Menu.Item>
        </Menu>
      );
    }




    if (user.user_type === "RSO") {
      menu = (
        <Menu>
          {typeof this.props.is_callpage !== "undefined" ? (
            <Menu.Item
              key="profile"
              onClick={() => this.goTo("/customer/" + bfile.id)}
            >
              <Icon type="user" style={{ marginRight: 10, color: "#1890ff" }} />
              <Translate text={`View Profile`} />
            </Menu.Item>
          ) : null}
          {typeof this.props.is_callpage !== "undefined" ? (
            <Menu.Divider />
          ) : null}
          <Menu.Item
            key="onboarding"
            onClick={() => this.goTo("/onboarding/step/1/" + bfile.id)}
          >
            <Icon type="phone" style={{ marginRight: 10, color: "#1890ff" }} />
            <Translate text={`Welcome/Thank You Call to Customer (Step 1)`} />
          </Menu.Item>
          <Menu.Item
            key="delete-financial"
            onClick={() => this.removeFinancialSpecialist()}
          >
            <Icon type="delete" style={{ marginRight: 10, color: "#1890ff" }} />
            <Translate text={`Remove Financial Specialist`} />
          </Menu.Item>
          <Menu.Item
            key="setup-appointment"
            onClick={() => this.setState({ setup_appointment_modal: true })}
          >
            <Icon type="phone" style={{ marginRight: 10, color: "#1890ff" }} />
            <Translate text={`Setup Appointment`} />
          </Menu.Item>
          <Menu.Item
            key="setup-appointment"
            onClick={() => this.setState({ edit_bfile_status_modal: true })}
          >
            <Icon type="edit" style={{ marginRight: 10, color: "#1890ff" }} />
            <Translate text={`Edit B File Status`} />
          </Menu.Item>
          <Menu.Item key="delete" onClick={() => this.setState({ show_delete_modal: true })}>
            <Icon type="delete" style={{ marginRight: 10, color: "#1890ff" }} />
            <Translate text={`Delete B File`} />
          </Menu.Item>
        </Menu>
      );
    }

    var { refresh, ...otherProps } = this.props;
    return (
      <div style={{ display: "inline-block" }}>
        {typeof this.props.is_callpage !== "undefined" ? (
          <Dropdown overlay={menu} getPopupContainer={() => document.body}>
            <div style={{ display: "flex", alignItems: "center", maxWidth: 180 }}>
              <Icon type="user" style={{ marginRight: 10 }} />

              <NavLink
                to={{
                  pathname: "/customer/" + bfile.id,
                  state: { ...this.props.history.location.state }
                }}
                style={{
                  display: "flex",
                  alignItems: "center",
                  maxWidth: "100%"
                }}
              >
                <span
                  style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    maxWidth: 160,
                    display: "inline-block"
                  }}
                >
                  {F.stripHtml(`${bfile.first_name || ""} ${bfile.last_name || ""}`.trim())}
                </span>

                <Icon type="down" style={{ marginLeft: 5 }} />
              </NavLink>
            </div>
          </Dropdown>
          // <Dropdown overlay={menu} getPopupContainer={() => document.body}>
          //   <div>
          //     <Icon type="user" style={{ marginRight: 10 }} />
          //     <NavLink to={{ pathname: "/customer/" + bfile.id, state: { ...this.props.history.location.state } }}>
          //       <span>
          //         {F.stripHtml(`${bfile.first_name || ""} ${bfile.last_name || ""}`.trim())}
          //       </span>{" "}
          //       <Icon type="down" />
          //     </NavLink>
          //   </div>
          // </Dropdown>
        ) : (
          <Dropdown
            trigger={["click"]}
            // getPopupContainer={() => document.body}
            visible={this.state.visible}
            onVisibleChange={(flag) => this.setState({ visible: flag })}
            overlay={menu}
          >
            <Button type="default" style={{ width: "265px", height: "30px", borderRadius: "20px", display: "flex", justifyContent: "space-between", alignItems: "center", padding: "0 20px" }}>
              <Translate text={`B File Actions`} />
              {this.state.visible ? (
                <Icon type="up" style={{ fontSize: 16 }} />
              ) : (
                <Icon type="down" style={{ fontSize: 16 }} />
              )}
            </Button>
          </Dropdown>
        )}

        {/* change_creator_modal check  */}
        {
          this.state.change_creator_modal && (
            <ChangeCreatorModal
              history={this.props.history}
              showModal={this.state.change_creator_modal}
              hideModal={() => this.setState({ change_creator_modal: false })}
              bfile={bfile}
              user={user}
              {...this.props}
            />
          )
        }
        {this.state.setup_appointment_modal && this.props.bfile ? (
          <SetupAppointment
            history={this.props.history}
            showModal={this.state.setup_appointment_modal}
            hideModal={() => this.setState({ setup_appointment_modal: false })}
            bfile={this.props.bfile}
            user={user}
            // {...this.props}
            {...otherProps}
          />
        ) : null}
        {this.state.setup_appointment_modal_von && this.props.bfile ? (
          <SetupAppointmentVon
            history={this.props.history}
            showModal={this.state.setup_appointment_modal_von}
            hideModal={() =>
              this.setState({ setup_appointment_modal_von: false })
            }
            bfile={this.props.bfile}
            user={user}
            // {...this.props}
            {...otherProps}
          />
        ) : null}
        <EditBFileStatusModal
          history={this.props.history}
          showModal={this.state.edit_bfile_status_modal}
          hideModal={() => this.setState({ edit_bfile_status_modal: false })}
          bfile={bfile}
          user={user}
          {...this.props}
        />
        {/* TransferBFile modal check */}
        {
          this.state.transfer_bfile_modal && (
            <TransferBFile
              history={this.props.history}
              showModal={this.state.transfer_bfile_modal}
              hideModal={() => this.setState({ transfer_bfile_modal: false })}
              bfile={bfile}
              user={user}
              {...this.props}
            />
          )
        }
        {/* InvitationLinkModal  check   */}
        {
          this.state.invitation_link_modal && (
            <InvitationLinkModal
              history={this.props.history}
              showModal={this.state.invitation_link_modal}
              hideModal={() => this.setState({ invitation_link_modal: false })}
              bfile={bfile}
              user={user}
              {...this.props}
            />
          )
        }
        {/* ResendMortgageApprovalModal check  */}
        {
          this.state.resend_mortgage_approval_modal && (
            <ResendMortgageApprovalModal
              history={this.props.history}
              showModal={this.state.resend_mortgage_approval_modal}
              hideModal={() =>
                this.setState({ resend_mortgage_approval_modal: false })
              }
              bfile={bfile}
              user={user}
              {...this.props}
            />
          )
        }
        {this.state.data && Object.keys(this.state.data).length > 0 && Object.keys(bfile).length > 0 && <PrintableContent
          ref={this.printRef}
          user={user}
          bfile={bfile}
          data={this.state.data}
          agency_owner_details={this.state.agency_owner_details}
        />}
        {this.state.show_print_modal &&
          <React.Fragment>
            {this.printRef.current &&
              (
                <HandlePrint contentRef={this.printRef}
                  hideModal={() => {
                    this.setState({ show_print_modal: false })
                  }}
                />
              )
            }
          </React.Fragment>
        }
        {this.state.show_delete_modal && (
          <DeleteModal
            hideModal={this.hideModal}
            show_delete_modal={this.state.show_delete_modal}
            onDeleteOk={this.onDeleteOk}
            isDeleting={this.state.isDeleting}
          />
        )}
      </div>
    );
  }
}

export default ActionMenu;



// WEBPACK FOOTER //
// ./src/scenes/LandingPage/menu.js